/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1SecurityDayState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_INVENTORY_V1_SECURITY_DAY_STATE_ENTITY_NAME = 'ixc.inventory.v1.SecurityDay';
export const ixcInventoryV1SecurityDayStateEntity = new schema.Entity<IxcInventoryV1SecurityDayState>(IXC_INVENTORY_V1_SECURITY_DAY_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcInventoryV1SecurityDayState) => `${entity.assetId}-${entity.tradeDate}` });

